import Vue from 'vue';
import Router from 'vue-router';
import home from '@/views/Home.vue';
import carListImport from '@/views/BrandListImport.vue';
import carListLocal from '@/views/BrandListLocal.vue';
import faq from '@/views/Faq.vue';
import estimate from '@/views/CarEstimate.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: home,
    },
    //   {
    //     path: '/lease',
    //     component: lease,
    //   },
    {
      path: '/carlistimport',
      component: carListImport,
    },
    {
      path: '/carlistlocal',
      component: carListLocal,
    },
    {
      path: '/estimate/:bid',
      component: estimate,
    },
    {
      path: '/faq',
      component: faq,
    },
  ],
});
